var FontsSizeEnum;
(function (FontsSizeEnum) {
    FontsSizeEnum["XxSmall"] = "xx-small";
    FontsSizeEnum["XSmall"] = "x-small";
    FontsSizeEnum["Small"] = "small";
    FontsSizeEnum["Base"] = "base";
    FontsSizeEnum["Large"] = "large";
    FontsSizeEnum["LargeXl"] = "large-xl";
    FontsSizeEnum["Large2xl"] = "large-2xl";
    FontsSizeEnum["Large3xl"] = "large-3xl";
    FontsSizeEnum["Large4xl"] = "large-4xl";
    FontsSizeEnum["Large5xl"] = "large-5xl";
    FontsSizeEnum["Large6xl"] = "large-6xl";
})(FontsSizeEnum || (FontsSizeEnum = {}));
var FontSizesXsEnum;
(function (FontSizesXsEnum) {
    FontSizesXsEnum["XsXxSmall"] = "xs-xx-small";
    FontSizesXsEnum["XsXSmall"] = "xs-x-small";
    FontSizesXsEnum["XsSmall"] = "xs-small";
    FontSizesXsEnum["XsBase"] = "xs-base";
    FontSizesXsEnum["XsLarge"] = "xs-large";
    FontSizesXsEnum["XsLargeXl"] = "xs-large-xl";
    FontSizesXsEnum["XsLarge2xl"] = "xs-large-2xl";
    FontSizesXsEnum["XsLarge3xl"] = "xs-large-3xl";
    FontSizesXsEnum["XsLarge4xl"] = "xs-large-4xl";
    FontSizesXsEnum["XsLarge5xl"] = "xs-large-5xl";
    FontSizesXsEnum["XsLarge6xl"] = "xs-large-6xl";
})(FontSizesXsEnum || (FontSizesXsEnum = {}));
var FontSizesSmEnum;
(function (FontSizesSmEnum) {
    FontSizesSmEnum["SmXxSmall"] = "sm-xx-small";
    FontSizesSmEnum["SmXSmall"] = "sm-x-small";
    FontSizesSmEnum["SmSmall"] = "sm-small";
    FontSizesSmEnum["SmBase"] = "sm-base";
    FontSizesSmEnum["SmLarge"] = "sm-large";
    FontSizesSmEnum["SmLargeXl"] = "sm-large-xl";
    FontSizesSmEnum["SmLarge2xl"] = "sm-large-2xl";
    FontSizesSmEnum["SmLarge3xl"] = "sm-large-3xl";
    FontSizesSmEnum["SmLarge4xl"] = "sm-large-4xl";
    FontSizesSmEnum["SmLarge5xl"] = "sm-large-5xl";
    FontSizesSmEnum["SmLarge6xl"] = "sm-large-6xl";
})(FontSizesSmEnum || (FontSizesSmEnum = {}));
var FontSizesMdEnum;
(function (FontSizesMdEnum) {
    FontSizesMdEnum["MdXxSmall"] = "md-xx-small";
    FontSizesMdEnum["MdXSmall"] = "md-x-small";
    FontSizesMdEnum["MdSmall"] = "md-small";
    FontSizesMdEnum["MdBase"] = "md-base";
    FontSizesMdEnum["MdLarge"] = "md-large";
    FontSizesMdEnum["MdLargeXl"] = "md-large-xl";
    FontSizesMdEnum["MdLarge2xl"] = "md-large-2xl";
    FontSizesMdEnum["MdLarge3xl"] = "md-large-3xl";
    FontSizesMdEnum["MdLarge4xl"] = "md-large-4xl";
    FontSizesMdEnum["MdLarge5xl"] = "md-large-5xl";
    FontSizesMdEnum["MdLarge6xl"] = "md-large-6xl";
})(FontSizesMdEnum || (FontSizesMdEnum = {}));
var FontSizesLgEnum;
(function (FontSizesLgEnum) {
    FontSizesLgEnum["LgXxSmall"] = "lg-xx-small";
    FontSizesLgEnum["LgXSmall"] = "lg-x-small";
    FontSizesLgEnum["LgSmall"] = "lg-small";
    FontSizesLgEnum["LgBase"] = "lg-base";
    FontSizesLgEnum["LgLarge"] = "lg-large";
    FontSizesLgEnum["LgLargeXl"] = "lg-large-xl";
    FontSizesLgEnum["LgLarge2xl"] = "lg-large-2xl";
    FontSizesLgEnum["LgLarge3xl"] = "lg-large-3xl";
    FontSizesLgEnum["LgLarge4xl"] = "lg-large-4xl";
    FontSizesLgEnum["LgLarge5xl"] = "lg-large-5xl";
    FontSizesLgEnum["LgLarge6xl"] = "lg-large-6xl";
})(FontSizesLgEnum || (FontSizesLgEnum = {}));
var FontSizesXlEnum;
(function (FontSizesXlEnum) {
    FontSizesXlEnum["XlXxSmall"] = "xl-xx-small";
    FontSizesXlEnum["XlXSmall"] = "xl-x-small";
    FontSizesXlEnum["XlSmall"] = "xl-small";
    FontSizesXlEnum["XlBase"] = "xl-base";
    FontSizesXlEnum["XlLarge"] = "xl-large";
    FontSizesXlEnum["XlLargeXl"] = "xl-large-xl";
    FontSizesXlEnum["XlLarge2xl"] = "xl-large-2xl";
    FontSizesXlEnum["XlLarge3xl"] = "xl-large-3xl";
    FontSizesXlEnum["XlLarge4xl"] = "xl-large-4xl";
    FontSizesXlEnum["XlLarge5xl"] = "xl-large-5xl";
    FontSizesXlEnum["XlLarge6xl"] = "xl-large-6xl";
})(FontSizesXlEnum || (FontSizesXlEnum = {}));
var FontSizesXxlEnum;
(function (FontSizesXxlEnum) {
    FontSizesXxlEnum["XxlXxSmall"] = "xxl-xx-small";
    FontSizesXxlEnum["XxlXSmall"] = "xxl-x-small";
    FontSizesXxlEnum["XxlSmall"] = "xxl-small";
    FontSizesXxlEnum["XxlBase"] = "xxl-base";
    FontSizesXxlEnum["XxlLarge"] = "xxl-large";
    FontSizesXxlEnum["XxlLargeXl"] = "xxl-large-xl";
    FontSizesXxlEnum["XxlLarge2xl"] = "xxl-large-2xl";
    FontSizesXxlEnum["XxlLarge3xl"] = "xxl-large-3xl";
    FontSizesXxlEnum["XxlLarge4xl"] = "xxl-large-4xl";
    FontSizesXxlEnum["XxlLarge5xl"] = "xxl-large-5xl";
    FontSizesXxlEnum["XxlLarge6xl"] = "xxl-large-6xl";
})(FontSizesXxlEnum || (FontSizesXxlEnum = {}));

const FONTS_WEIGHT = 'f-400';
const FONTS_FAMILY = 'f-inter';
const FONTS_ALIGN = 'left';

export { FontsSizeEnum as F, FONTS_FAMILY as a, FONTS_WEIGHT as b, FONTS_ALIGN as c };
